/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 消息相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 未读消息数量
  getMessageStatus(data) {
    return request({
      url: "/message/getMessageStatus?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 消息列表
  getMessageList(data) {
    return request({
      url: "/message/getMessageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 阅读消息
  readMessage(data) {
    return request({
      url: "/message/readMessage",
      method: "post",
      data,
    });
  },
};
